// extracted by mini-css-extract-plugin
export var arrows = "_6p-6";
export var decrementer = "_6p-a";
export var disabled = "_6p-4";
export var error = "_6p-1";
export var hiddenText = "_6p-b";
export var incrementer = "_6p-9";
export var input = "_6p-8";
export var inputWrapper = "_6p-0";
export var leadingIcon = "_6p-c";
export var readonly = "_6p-3";
export var regular = "_6p-7";
export var small = "_6p-5";
export var warning = "_6p-2";